import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function render() {
  const paragraph = document.querySelector(".l-customers__content");
  const customers = paragraph.textContent.split(" ");
  paragraph.innerHTML = " ";

  customers.forEach((el) => {
    const span = document.createElement("span");
    span.innerHTML = el + " ";
    span.classList.add("-js-word");
    paragraph.appendChild(span);
  });

  let showCustomers = gsap.timeline({
    scrollTrigger: {
      end: "bottom 75%",
      scroller: ".smooth-scroll",
      scrub: true,
      start: "top 75%",
      trigger: ".l-customers",
    },
  });

  showCustomers.to(".-js-word", {
    opacity: 1,
    stagger: {
      each: 0.05,
    },
  });
}
